<template>
  <div>
    <div class="header"></div>
    <div class="login-box">
      <div class="w">
        <div class="logo-box">
          <!-- logo S -->
          <div class="logo fl">
            <router-link to="/" style="display: block">
              www.rakumart-2c.com
            </router-link>
          </div>
          <div class="fl fenge"></div>
          <h2>ログイン</h2>
          <!-- logo E -->
        </div>
        <div class="login">
          <div class="login-img fl">
            <img src="../../assets/login/bg2.png" alt />
          </div>
          <div class="login-from fl">
            <h3>ログイン画面</h3>
            <!-- 登录表单 -->
            <ul>
              <li>
                <el-input prefix-icon="el-icon-s-custom" v-model="loginFrom.user"></el-input>
              </li>
              <li>
                <el-input prefix-icon="el-icon-lock" type="password" v-model="loginFrom.password"></el-input>
              </li>
              <li>
                <input type="checkbox" @change="loginFrom.agreement = !loginFrom.agreement" />
                <span style="font-weight: 700">ログイン状態を維持する</span>
                <!-- <div class="forget fr">
                  <router-link to="/">パスワードを忘れた場合？</router-link>
                </div> -->
              </li>
              <li class="sbumit">
                <button @click="login" @keyup.enter="login">ログイン</button>
              </li>
              <li class="member">
                <span>問合せ</span>
                <router-link to="/register">無料・新規会員登録</router-link>
                <!-- <div class="tb fr">
                  follow us：
                  <img src="../../assets/login/tb1.png" alt />
                  <img src="../../assets/login/tb2.png" alt />
                </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../../components/foot/Foot";
import { mapState, mapMutations } from "vuex";
import { login } from "../../api/API/login";
import { log } from "util";
export default {
  data() {
    return {
      // 登入表单
      loginFrom: {
        user: "",
        password: "",
        agreement: false,
      },
    };
  },
  components: {
    Foot,
  },
  created() { },
  mounted() {
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.login(); // 登录方法名
        return false;
      }
    };
  },
  methods: {
    ...mapMutations(["userLogin"]),
    ...mapState(["userInfo", "toPageName"]),
    login() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "login",
        username: this.loginFrom.user,
        password: this.loginFrom.password,
        keepLogin: this.loginFrom.agreement ? 1 : 0,
      };
      if (this.loginFrom.user == "")
        return this.$message.error("ユーザー名を入力してください");
      if (this.loginFrom.password == "")
        return this.$message.error("暗証番号を入力してください");
      login(list).then((res) => {
        if (res.code != 1)
          return this.$message.error(
            "パスワードまたはアカウント名が間違っています。"
          );
        localStorage.setItem("token", res.data.token);
        this.userLogin(res);
        if (this.$store.state.toPageName == null) {
          this.$router.push("/");
        } else {
          this.$router.push(this.$store.state.toPageName);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  height: 30px;
  width: 100%;
  background: #eee;
}

.login-box {
  height: 854px;

  .logo-box {
    height: 155px;
    overflow: hidden;

    .logo {

      height: 104px;
      margin: 25px 85px 25px 25px;
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        color: #f3c622;
        font-size: 30px;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }

    .fenge {
      height: 40px;
      width: 2px;
      background: #ccc;
      margin: 55px 60px 0 0;
    }

    h2 {
      line-height: 155px;
      font-size: 30px;
      font-weight: 700;
      color: #333;
    }
  }

  .login {
    height: 500px;
    background: url(../../assets/login/bg1.png);
    background-size: 100%;
    font-size: 12px;

    .login-img {
      margin: 20px 150px 0 67px;
      height: 451px;
      width: 623px;

      img {
        height: 451px;
        width: 623px;
      }
    }

    .login-from {
      width: 408px;
      height: 460px;
      margin-top: 20px;
      background: url(../../assets/login/loginbg.png) no-repeat;
      background-size: 100%;
      overflow: hidden;

      h3 {
        font-size: 30px;
        font-weight: 700;
        text-align: center;
        margin: 43px 0;
      }

      ul {
        li {
          height: 40px;
          margin-bottom: 20px;

          input {
            width: 15px;
            height: 15px;
            vertical-align: middle;
          }
        }

        margin: 0 30px;

        /deep/.el-input__inner {
          height: 40px;
          width: 348px;
        }

        .forget {
          a {
            color: #4379ba;
            font-size: 12px;
          }
        }

        .sbumit {
          margin-top: 60px;
          margin-bottom: 30px;

          button {
            display: block;
            width: 348px;
            height: 40px;
            font-size: 18px;
            font-weight: 700;
            color: #fff;
            background: #113e74;
            cursor: pointer;
          }
        }

        .member {
          font-size: 12px;

          span {
            font-weight: 700;
          }

          a {
            padding-left: 15px;
            color: #333;
            font-weight: 700;
          }

          .tb {
            img {
              vertical-align: middle;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>